import Vue from 'vue';
import VueRouter, {RouteConfig} from "vue-router";
import store from '@/store';
import RouterView from "./components/RouterView.vue"
import i18n from "@/plugins/translations/t";
import Hildegard from "@/components/Hildegard.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: '/:lang(en|et|uk|la)',
        component: RouterView,
        children: [
            {
                path: '/',
                component: Hildegard,
                name: "hildegard"
            },
            {
                path: 'garden',
                component: () => import('./components/CommunityGarden.vue'),
                name: "kogukonna_aed"
            },
            {
                path: 'plants',
                component: () => import('./components/Plants.vue'),
                name: "plants"
            },
            {
                path: 'profile',
                name: 'profile',
                // lazy-loaded
                component: () => import('./components/Profile.vue')
            },
            {
                path: 'management',
                name: 'management',
                // lazy-loaded
                component: () => import('./components/Management.vue')
            },
            {
                path: 'login',
                name: 'login',
                component: () => import('./components/Login.vue')
            },
            {
                path: 'plant/edit/:id',
                name: 'plant_edit',
                component: () => import('./components/PlantEdit.vue')
            },
            {
                path: 'plant/:id',
                name: 'plant',
                component: () => import('./components/Plant.vue')
            },
            {
                path: '(.*)',
                redirect: () => {
                    return "/" + i18n.locale;
                }
            }
        ]
    },
    {
        path: "/(.*)",
        redirect: (to: any) => {
            return "/et" + to.path;
        }
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

router.beforeEach(async (to, from, next) => {
    const secretPages = ['/management'];
    const authRequired = secretPages.includes(to.path);

    if (authRequired && !store.state.Auth.status.loggedIn) {
        await store.dispatch('Auth/loadUser');
    }

    // trying to access a restricted page + not logged in
    // redirect to login page
    if (authRequired && !store.state.Auth.status.loggedIn) {
        next('login');
    } else {
        next();
    }
});

export default router;


